// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".AddressAutocompleteInput-triggerAnchor__nYq7t{width:var(--size-full)}.AddressAutocompleteInput-list__r35K7{width:100%;width:var(--popover-trigger-width, 100%);min-width:var(--popover-trigger-width, var(--size-64))}.AddressAutocompleteInput-attribution__WEUm2{display:flex;align-items:center;justify-content:center;height:var(--size-7);color:var(--gray-a9);font:var(--font-caption-small-400);font-feature-settings:var(--feature-settings-caption-small-400);letter-spacing:var(--letter-spacing-caption-small-400)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"triggerAnchor": "AddressAutocompleteInput-triggerAnchor__nYq7t",
	"list": "AddressAutocompleteInput-list__r35K7",
	"attribution": "AddressAutocompleteInput-attribution__WEUm2"
};
export default ___CSS_LOADER_EXPORT___;
